import { Headline } from '@absolutelabs/react-component-library';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFont from '../../../../../components/hooks/useFont';
import {
  selectCurrPage,
  selectFieldSettings,
  selectFormTextColor,
} from '../../../../../store/reducers/forms';

const HeadlineText = ({ field }) => {
  const currPage = useSelector(selectCurrPage);
  const fieldSettings = useSelector(selectFieldSettings);
  const globalTextColor = useSelector(selectFormTextColor);
  const [fieldConfig, setFieldConfig] = useState({});
  const { font } = useFont('headline');

  useEffect(() => {
    const currPageSettings = fieldSettings.find((o) => o.pageName === currPage);
    const config = currPageSettings?.fields?.find(
      (x) => x.field_id === field?.id
    );
    if (config) {
      setFieldConfig(config);
    }
  }, [fieldSettings, currPage, field?.id]);

  return (
    <Headline
      label={fieldConfig.label || 'Headline'}
      textAlignment={fieldConfig.textAlignment || 'left'}
      styleTag={fieldConfig.styleTag || 'h1'}
      textColor={globalTextColor}
      font={font}
    />
  );
};

export default HeadlineText;
